import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { TranscriptTimeInput } from './TranscriptTimeInput';
import { useEditedIntervalSync } from './useEditedIntervalSync';

type Props = {
  /** Отрезок этой формы выделяется на шкале записи */
  isTimelineTarget: boolean;
};

/**
 * Начало и конец записи. Пока форма открыта, её отрезок выделен на шкале записи.
 */
export const TranscriptTimeFields: FC<Props> = ({ isTimelineTarget }) => {
  const { t } = useTranslation(['dialogs']);
  useEditedIntervalSync(isTimelineTarget);

  return (
    <div className="grid grid-cols-1 @xs:grid-cols-2 gap-3">
      <TranscriptTimeInput name="startedAt" label={t('dialogs:transcriptEdit.startedAt')} />
      <TranscriptTimeInput name="finishedAt" label={t('dialogs:transcriptEdit.finishedAt')} />
    </div>
  );
};
